module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/spot_american-village-669dcbe565bb94f8dc9dca783abe6420.png";